<template>
  <nx-auth-card
    :title="title"
    login-method="user-password-login"
    v-on="$listeners"
  >
    <nx-form
      ref="form"
      @form="form = $event"
      @submit.prevent="submit"
    >
      <nx-form-text
        v-model="username"
        :autofocus="!username && !submitted"
        :label="$t('message.form.fields.username')"
        append-icon="account_circle"
        name="username"
        validation="required"
      />
      <div>
        <nx-form-password
          v-model="password"
          :autofocus="!submitted"
          :label="$t('message.form.fields.password')"
          name="password"
          validation="required"
        />
        <ds-text
          v-if="staffPasswordRecoveryEnabled"
          align="right"
        >
          <a
            @click="recoverPassword"
            v-text="$t('message.login.forgotPassword.title')"
          />
        </ds-text>
      </div>
      <v-btn
        :disabled="form.invalid || form.pristine"
        :loading="loading"
        block
        type="submit"
        color="secondary"
      >
        {{ $t('message.login.login') }}
      </v-btn>
    </nx-form>
  </nx-auth-card>
</template>

<script>
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import NxFormText from '@/modules/form/components/FormText.vue';
import NxFormPassword from '@/modules/form/components/FormPassword.vue';
import NxForm from '@/modules/form/Form.vue';
import { mapGetters } from 'vuex';
import { LOGIN_PAGE_ID_FORGOT_PASSWORD } from '@/modules/authentication/config/login-routes';
import AuthComponent from '@/modules/authentication/mixins/auth-component';

export default {
  name: 'NxAuthUserPasswordLogin',
  components: {
    NxFormPassword,
    NxFormText,
    NxAuthCard,
    NxForm,
  },
  mixins: [AuthComponent],
  props: {
    nick: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      username: this.nick,
      password: '',
      submitted: false,
      form: {},
    };
  },
  computed: {
    ...mapGetters(['oAuthEnabled', 'staffPasswordRecoveryEnabled']),
    title() {
      if (this.isLoginPage) {
        return this.$t('message.login.loginPageTitle');
      }
      return this.$t('message.login.sessionExpired');
    },
  },
  methods: {
    setInvalidState() {
      this.$refs.form.errors.add({
        field: 'username',
        msg: this.$t('message.login.invalidCredentials'),
      });
    },
    async submit() {
      if (this.loading) {
        return;
      }
      this.submitted = true;

      try {
        const result = await this.dispatch(
          'authentication/LOGIN_STAFF',
          {
            nick: this.username,
            password: this.password,
          },
        );
        if (!result.success) {
          this.setInvalidState();
        }
      } catch (error) {
        this.setInvalidState();
      }
    },
    recoverPassword() {
      this.redirectToLoginPage(LOGIN_PAGE_ID_FORGOT_PASSWORD);
    },
  },
};
</script>
